'use client'
import { Dropdown, DropdownTrigger } from '@heroui/react'
import { Settings } from 'lucide-react'
import SettingsMenu from './SettingsMenu'

export default function SettingsButton() {
  return (
    <>
      <Dropdown>
        <DropdownTrigger aria-label="Open settings">
          <button type={'button'}>
            <Settings />
          </button>
        </DropdownTrigger>

        <SettingsMenu />
      </Dropdown>
    </>
  )
}
